import moment from "moment";

interface MatchInfoProps {
  eventName?: string;
  awayTeam: string;
  homeTeam: string;
  openDate: Date;
}

const MatchInfo: React.FC<MatchInfoProps> = ({
  eventName,
  awayTeam,
  homeTeam,
  openDate,
}) => {
  return (
    <div className="bg-blue31 mt-[1px] w-full text-white p-2">
      <div className="flex flex-row sm:flex-row justify-between items-center">
        <p className="text-sm sm:text-base mb-2 sm:mb-0 capitalize">
          {homeTeam && awayTeam
            ? homeTeam + " vs " + awayTeam
            : eventName?.toLowerCase() === "binary"
            ? "Binary"
            : eventName?.split("-").join(" ")}
        </p>
        <p className="text-sm sm:text-base">
          {moment(openDate).format("DD MMM YYYY")}{" "}
          {moment(openDate).format("hh : mm A")}
        </p>
      </div>
    </div>
  );
};

export default MatchInfo;
